// Le journal des mises à jour (CHANGELOG.md) en blocs simples pour la fenêtre « Nouveautés » :
// titres (## version, ### onglet), puces sur deux niveaux, paragraphes. Testé dans tests/journal.test.js.
export function lisJournal(texte) {
  return String(texte).split('\n').map((ligne) => {
    if (ligne.startsWith('## ')) return { type: 'version', texte: ligne.slice(3) };
    if (ligne.startsWith('### ')) return { type: 'rubrique', texte: ligne.slice(4) };
    if (/^\s{2,}- /.test(ligne)) return { type: 'sous', texte: ligne.trim().slice(2) };
    if (ligne.startsWith('- ')) return { type: 'puce', texte: ligne.slice(2) };
    if (ligne.startsWith('# ') || !ligne.trim()) return null;
    return { type: 'texte', texte: ligne };
  }).filter(Boolean);
}
